module.exports = __webpack_public_path__ + "static/img/ket-renewal-pc-main-01@m.f7b3458.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-pc-main-01@m.png
// module id = g6db
// module chunks = 0